import type { TableNode, TableRowNode } from "@lexical/table";

/**
 * Reorder rows in a table (simple tables only; no merged cells).
 * Uses detach + append to preserve row order in the document.
 */
export function $moveTableRow(tableNode: TableNode, fromIndex: number, toIndex: number): void {
  const table = tableNode.getWritable();
  const rows = [...table.getChildren()] as TableRowNode[];
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= rows.length || toIndex >= rows.length) return;
  if (fromIndex === toIndex) return;
  const [moved] = rows.splice(fromIndex, 1);
  rows.splice(toIndex, 0, moved);
  for (const r of rows) {
    r.remove();
  }
  for (const r of rows) {
    table.append(r);
  }
}
